"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DetailsList_base_1 = require("./DetailsList.base");
var DetailsList_styles_1 = require("./DetailsList.styles");
exports.DetailsList = Utilities_1.styled(DetailsList_base_1.DetailsListBase, DetailsList_styles_1.getStyles, undefined, {
    scope: 'DetailsList'
});
//# sourceMappingURL=DetailsList.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DetailsList/DetailsList.js
// module id = 906
// module chunks = 0